import * as React from "react";
import { Button, Divider, AppBar as MuiAppbar, Box, Typography, IconButton, Grid, MenuItem, Menu, Container } from "@mui/material";

import MenuIcon from "@mui/icons-material/Menu";
import { useSlideInContext } from "ui";
import { CHANGE_PASSWORD, ChangePasswordPayload } from "ft-shared-components";
import usePersonStore from "../../store/personStore";
import usePersonAuthStore from "../../store/personAuthStore";
import { useState } from "react";
import { useNavigate } from "react-router";
import { useMainMenuContext } from "../MainMenu/MainMenuProvider";
import axios from "axios";
import { Home } from "@mui/icons-material";

function AppMenu({ menuItems, roles, ...rest }: any) {

  const [menuAnchorElement, setMenuAnchorElement] =
    useState<HTMLElement | null>(null);

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setMenuAnchorElement(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setMenuAnchorElement(null);
  };

  // Separate signout menu item because we want ensure it's always placed at the bottom of the menu
  // and make injection of location menu item component "simpler"
  const signoutMenuItem = menuItems.find(
    (x: any) => x.id === "bac2d789-c2f0-40ae-90c5-e52f33ad0323"
  );
  const menuItemsFiltered = menuItems

    .filter((x: any) => x.id !== "bac2d789-c2f0-40ae-90c5-e52f33ad0323");
  return (
    /* @ts-ignore */
    <Box component="div" {...rest}>
      <IconButton data-tour="user-menu"
        size="large"
        edge="start"
        color="inherit"
        aria-label="menu"
        onClick={handleOpenMenu}
      >
        <MenuIcon sx={{ fontSize: "36px" }} />
      </IconButton>
      <Menu
        id="menu-appbar"
        anchorEl={menuAnchorElement}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Boolean(menuAnchorElement)}
        onClose={handleCloseMenu}
        PaperProps={{
          elevation: 10,
          sx: {
            overflow: "visible",
            width: 250,
          },
        }}
      >
        {menuItemsFiltered.map((item: any) => [
          <MenuItem
            key={item.id}
            onClick={() => {
              item.onClick();
              handleCloseMenu();
            }}
          >
            {item.label}
          </MenuItem>,
        ])}
        <Divider />
        <MenuItem onClick={signoutMenuItem.onClick}>
          {signoutMenuItem.label}
        </MenuItem>
      </Menu>
    </Box>
  );
}


export default function AppBar() {
  const navigate = useNavigate();
  const { handleContent, toggleDrawer } = useSlideInContext();
  const destroyPersonStore = usePersonStore((state) => state.destroy);
  const username = usePersonStore(state => state.name);
  const personId = usePersonStore(state => state.id);
  const roles = usePersonAuthStore((state) => state.roles);
  const accessToken = usePersonAuthStore((state) => state.access_token)
  const destroyPersonAuthToken = usePersonAuthStore((state) => state.destroy);
  const { toggleMenu, openMenu } = useMainMenuContext();
  const handleSignout = () => {
    destroyPersonAuthToken();
    destroyPersonStore();
    navigate("/login");
  };
  const handleChangePassword = async (data: ChangePasswordPayload) => {
    var payload = JSON.stringify({
      "id": personId,
      "newPassword": data.newPassword,
      "oldPassword": data.oldPassword,
      "confirmPassword": data.confirmNewPassword,
    })

    var config = {
      method: 'post',
      url: `${window.__env.API_URL}/api/oauth/change-password`,
      headers: {
        'Content-Type': 'application/json',
        authorization: `Bearer ${accessToken}`
      },
      data: payload
    };
    await axios(config)
    //@ts-ignore
    // await axios(config).then(() => {
    //   setUIState(SUCCESS)
    // }).catch(function (error: any) {
    //   setResponseError("Connection refused. Please try again later.");

    //   setUIState(ERROR)
    // });
  }
  const navigation = [
    {
      id: "1e4b3436-bf08-4a5d-930a-743865dac5ec",
      label: "Change Password",
      onClick: () => {
        handleContent(CHANGE_PASSWORD, {
          onSubmit: handleChangePassword
        });
        toggleDrawer();
      },
    },
    {
      id: "bac2d789-c2f0-40ae-90c5-e52f33ad0323",
      label: "Sign Out",
      onClick: () => {
        handleSignout();
      },
    },
  ];

  return (
    <MuiAppbar color="secondary" position="static">
      <Container maxWidth="xl">
        <Grid container>
          <Grid size={3}>
            <Button
              data-tour="main-menu"
              sx={{
                // position: "fixed",
                position: "relative",
                transition: theme =>
                  theme.transitions.create("transform", {
                    duration: theme.transitions.duration.enteringScreen,
                    easing: theme.transitions.easing.easeOut,
                  }),
                transform: openMenu ? "translateX(-500px)" : "translateX(0)",
                color: "#fff", textTransform: "none", fontWeight: "400", fontSize: "large"
              }}
              startIcon={<Box
                component="img"
                sx={{
                  marginTop: 1.3,
                  marginBottom: 1.5,
                  height: "45px",
                  width: "45px",
                  backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/logos/ft_logo_sm.jpg)`,
                  backgroundSize: "cover",
                  borderRadius: "15px",

                }} />}
              onClick={() => toggleMenu()}
            />
            <Button
              data-tour="home-button"

              sx={{
                position: "relative",
                transition: theme =>
                  theme.transitions.create("transform", {
                    duration: theme.transitions.duration.enteringScreen,
                    easing: theme.transitions.easing.easeOut,
                  }),
                transform: openMenu ? "translateX(-500px)" : "translateX(0)",
                color: "#fff", textTransform: "none", fontWeight: "400", fontSize: "large"

              }} startIcon={<Home sx={{
                fontSize: "36px", marginTop: 1.3,
                marginBottom: 1.5,
                height: "45px",
                width: "45px",
              }} />
              }
              onClick={() => navigate("/dashboard")} />

          </Grid>
          <Grid
            size={9}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
            }}
          >
            <Typography variant="h5" sx={{ fontWeight: "400" }}>
              {" "}
              {username ? `Welcome, ${username}` : ""}{" "}
            </Typography>
            <AppMenu
              sx={{ marginLeft: 1 }}
              menuItems={navigation}
              roles={roles}
            />
          </Grid>
        </Grid>
      </Container>
    </MuiAppbar>
  );
}
